import React from 'react';
import { Shield, Zap, Waves } from 'lucide-react';
export function Mechanism() {
  return <section className="py-20 md:py-32 relative" data-id="element-93">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-navy-800 via-navy-900 to-navy-900" data-id="element-94"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-95">
        <div className="max-w-4xl mx-auto text-center" data-id="element-96">
          <div className="inline-flex items-center justify-center p-3 bg-amber-500/10 rounded-full mb-6" data-id="element-97">
            <Shield className="text-amber-400" size={32} data-id="element-98" />
          </div>

          <h2 className="text-3xl md:text-5xl mb-8" data-id="element-99">
            El Protocolo de{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-steel-200 to-steel-400" data-id="element-100">
              "Vaciado de Acero"
            </span>
          </h2>

          <p className="text-xl text-steel-200 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-101">
            Es una técnica de neuro-consolidación nocturna diseñada para
            sincronizar tus ondas cerebrales justo antes del sueño.
          </p>

          <div className="glass-panel p-8 md:p-12 text-left relative overflow-hidden" data-id="element-102">
            <div className="absolute -right-10 -top-10 text-amber-500/5" data-id="element-103">
              <Waves size={200} data-id="element-104" />
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-center relative z-10" data-id="element-105">
              <div className="flex-1" data-id="element-106">
                <p className="text-lg text-steel-300 leading-relaxed" data-id="element-107">
                  Al combinar una{' '}
                  <strong className="text-white font-medium" data-id="element-108">
                    descarga física selectiva
                  </strong>{' '}
                  con un{' '}
                  <strong className="text-white font-medium" data-id="element-109">
                    audio de frecuencia dirigida
                  </strong>
                  , obligas a tu cerebro a mover la información crítica del
                  "pasillo de entrada" a la "biblioteca de almacenamiento a
                  largo plazo" en menos de 10 minutos.
                </p>
              </div>
              <div className="w-full md:w-auto flex justify-center" data-id="element-110">
                <div className="w-24 h-24 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center shadow-[0_0_40px_rgba(201,148,62,0.3)]" data-id="element-111">
                  <Zap className="text-navy-900" size={40} fill="currentColor" data-id="element-112" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}